import type { HttpGet, HttpRequest } from '@/shared/infra/http'
import type { ProSubscriptionSummary } from '@/shared/domain'
import type { LoadProSubscription } from '@/modules/auth/use-cases'

export class EdgeLoadProSubscriptionRepository {
  constructor(private readonly httpClient: HttpGet) {}

  execute: LoadProSubscription = async () => {
    const request: HttpRequest<never> = { url: '/pro-billing/subscription' }
    return this.httpClient.get<ProSubscriptionSummary>(request)
  }
}
